import React from "react";
import { LuWallet, LuTrendingUp, LuUsers, LuChartBar } from "react-icons/lu";
import KPICard from "./KPICard";
import RevenueByCrewChart from "./RevenueByCrewChart";

const SectionHeader = ({ title }) => (
  <div style={{ fontSize: "14px", fontWeight: "600", color: "#374151", marginBottom: "16px", paddingBottom: "8px", borderBottom: "1px solid #F3F4F6" }}>
    {title}
  </div>
);

const Card = ({ title, children }) => (
  <div style={{ background: "#fff", border: "1px solid #E5E7EB", borderRadius: "8px", padding: "20px" }}>
    <div style={{ fontSize: "14px", fontWeight: "600", color: "#374151", marginBottom: "16px" }}>{title}</div>
    {children}
  </div>
);

const RevenueTab = ({ metrics: m, currency = "AED", isClinicService, isSportsService, crewSingular = "Crew", crewPlural = "Crew" }) => {
  const bookingLabel = isClinicService ? "Appointment" : "Booking";
  const customerLabel = isClinicService ? "Patient" : isSportsService ? "Player" : "Customer";
  return (
    <div style={{ animation: "fadeSlideUp 0.2s ease-out both" }}>
      {/* Revenue KPIs */}
      <SectionHeader title="Revenue KPIs" />
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", gap: "16px", marginBottom: "24px" }}>
        <KPICard animDelay={0}   icon={LuWallet}  label="Total Revenue"     current={m.totalRevenue.current}       previous={m.totalRevenue.previous}       metricKey="total_revenue"        format="currency" currency={currency} />
        <KPICard animDelay={50}  icon={LuChartBar}    label={`Revenue / ${bookingLabel}`} current={m.revenuePerBooking.current}  previous={m.revenuePerBooking.previous}  metricKey="revenue_per_booking"  format="currency" currency={currency} />
        <KPICard animDelay={100} icon={LuWallet}  label={`Revenue / ${crewSingular}`}   current={m.revenuePerCrewAvg.current}  previous={m.revenuePerCrewAvg.previous}  metricKey="revenue_per_crew"     format="currency" currency={currency} />
        <KPICard animDelay={150} icon={LuUsers}       label={`Total ${customerLabel}s`}  current={m.totalCustomers.current}     previous={m.totalCustomers.previous}     metricKey="total_customers" />
      </div>

      {/* Revenue by Crew */}
      <SectionHeader title={`Revenue by ${crewPlural}`} />
      <Card title={`Revenue per ${crewSingular} — This vs Previous Period`}>
        <RevenueByCrewChart data={m.revenuePerCrewBreakdown} currency={currency} />
      </Card>

      {/* Customer & Growth */}
      <SectionHeader title={`${customerLabel} & Growth`} />
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(180px, 1fr))", gap: "16px", margin: "16px 0 0" }}>
        <KPICard icon={LuUsers}      label={`Repeat ${customerLabel}s %`}  current={m.repeatCustomersPct.current}   previous={m.repeatCustomersPct.previous}   metricKey="repeat_customers_pct"  format="percent" />
        <KPICard icon={LuTrendingUp} label={`${bookingLabel}s / ${customerLabel}`} current={m.bookingsPerCustomer.current}  previous={m.bookingsPerCustomer.previous}  metricKey="bookings_per_customer" format="decimal" />
        <KPICard icon={LuChartBar}   label="Avg Jobs / Day"      current={m.avgJobsPerDay.current}        previous={m.avgJobsPerDay.previous}        metricKey="avg_jobs_per_day"      format="decimal" />
        <KPICard icon={LuWallet} label="Total Jobs Done"     current={m.totalJobsCompleted.current}   previous={m.totalJobsCompleted.previous}   metricKey="total_jobs_completed" />
      </div>
    </div>
  );
};

export default RevenueTab;
